import { SketchPicker } from "react-color";
const React = require("react");
export default class ColorSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      color: props.value,
      key: props.objKey,
      displayColorPicker: "none",
    };
    this.handleClick = this.handleClick.bind(this);
  }

  triggerChange = (changedValue) => {
    const onChange = this.props.onChange;
    if (onChange) {
      onChange(changedValue);
    }
  };

  handleClick = (e) => {
    e.preventDefault();
    let { displayColorPicker } = this.state;
    displayColorPicker = displayColorPicker === "none" ? "block" : "none";
    this.setState({ displayColorPicker });
    // if(displayColorPicker){
    //     this.props.updateColor(key,color)
    // }
  };

  handleChange = (e) => {
    const color = e.hex;
    this.triggerChange(color);
    this.setState({ color });
  };

  render() {
    const { color, displayColorPicker } = this.state;
    return (
      <div>
        <button
          type="button"
          onClick={this.handleClick}
          style={{
            borderRadius: "20px",
            marginLeft: "4px",
            background: color,
            border: "none",
            lineHeight: "22px",
            height: 22,
            width: 45,
            verticalAlign: "middle",
          }}>
        </button>
        {displayColorPicker === "block" ? (
          <div style={{ position: "flex", zIndex: 66 }}>
            <SketchPicker
              value={this.state.color}
              color={this.state.color}
              onChange={this.handleChange}
            />
          </div>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/AntD/components/display/color/ColorSelect.js